import * as $ from 'jquery';
import * as kendo from 'kendo/kendo.core';
import * as i18n from 'CMS/core/i18n';
import * as publisher from 'publisher';
import * as app from 'CMS/core/application';
import * as conf from 'CMS/conf';

export interface IPopupResizeIFrameOptions {
    $iframe?: JQuery;
    maxHeight?: number;
    maxWidth?: number;
}
export interface IPopupShowReturn {
    selection?: Promise<any>;
}
export interface IPopupShowOptions {
    title?: string;
    content?: string | JQuery;
    className?: string;
    anchor?: string;

    height?: number;
    width?: number;
    minHeight?: number;
    minWidth?: number;
    maximizable?: boolean;
    draggable?: boolean;

    global?: any;
    instance?: any;
    iidWidget?: string;
    widget?: any;
    params?: any;
    actionID?: string;
    page?: string;
    pageID?: string;
    url?: string;
    html?: string | JQuery;

    displayMode?: 'legacy' | 'flex';
    iframeVisible? : 'immediate' | 'onload';

    close?: (e: any) => void;
    widgetLoaded?: (widget: any) => void;
}
export interface IPopupConfirmOptions {
    className?: string;
    height?: number;
    width?: number;
    minHeight?: number;
    minWidth?: number;
    maximizable?: boolean;
    draggable?: boolean;

    confirmButtonText?: string;
    cancelButtonText?: string;
}
export interface IPopupAlertOptions {
    className?: string;
    height?: number;
    width?: number;
    minHeight?: number;
    minWidth?: number;
    maximizable?: boolean;
    draggable?: boolean;

    confirmButtonText?: string;
}
export interface IPopupOpenPageOptions {
    url?: string;
    target?: string;
    page?: string;
    pageID?: string;
    params: IPopupParamsArray;
}
interface IWidgetData {

}
export interface IKeyValuePair {
    Key: any;
    Value: any;
}
export interface IPopupParamsArray extends Array<IKeyValuePair> { }
export interface IPopupParamsObject {
    [key: string]: any
}

// 

var addedStyleSheets: Array<string> = [];
function addStyleSheets(urls: Array<string>, forceAdd: boolean = false) {
    for (var i = 0; i < urls.length; i++) {
        var url = urls[i];
        if (forceAdd || $.inArray(url, addedStyleSheets) < 0) {
            addedStyleSheets.push(url);
        }

        /* Check if document has a createStyleSheet function */
        if ((<any>document).createStyleSheet) {
            (<any>document).createStyleSheet(url);
        } else {
            $('<link rel="stylesheet" type="text/css" href="' + url + '" />').appendTo('head');
        }
    }
}


function isNumber(n: any): boolean {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function evaluateParams(val: any) {
    val = $.trim(val);
    if (val == "null") return null;
    if (isNumber(val)) return parseFloat(val);
    var _possibleStarters = ["'", '"', '{', "["];
    var _possibleStoppers = ["'", '"', '}', "]"];
    var _wrap = true;
    var _index = $.inArray(val.charAt(0), _possibleStarters);
    if ((_index != -1) && (val.charAt(val.length - 1) == _possibleStoppers[_index])) { _wrap = false; }

    var _val = (_wrap ? kendo.format('"{0}"', val.replace(/"/g, '\"')) : val);

    var evaluateValue = new Function('return ' + val + ';');
    return evaluateValue();
};
function serverSideToClientSideParams(params: Array<{ Key: string, Value: any }>) {
    var _ret: { [key: string]: any } = {};
    if (params) {
        $.each(params, function (key, value) {
            _ret[value.Key] = evaluateParams(value.Value);
        });
    }
    return _ret
}
function getScrollBarWidth(): number {
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;

    if (w1 == w2) {
        w2 = outer.clientWidth;
    }

    document.body.removeChild(outer);

    return (w1 - w2);
}


function getWidgetData(filter: string, fields?: string): Promise<any> {
    return new Promise((resolve, reject) => {
        var url = app.formatLocationUrl("~/odata/awfdataservice.svc/WebmoduleActions") + "?$filter=" + filter;
        if (fields && fields != "") {
            url += "&$select=" + fields;
        }
        var $req = $.ajax({
            url: url,
            dataType: 'json'
        });

        /* Resolve promise on success */
        $req.done((data) => {
            resolve(data);
        });

        /* Reject promise on fail */
        $req.fail((error) => {
            reject(error);
        })
    });
}

export function getParamStr(params: IPopupParamsArray | IPopupParamsObject) {
    if (params == null) { return ''; }

    var mappedParams: string[];
    if ($.isArray(params)) {
        mappedParams = $.map(params, function (val, key) {
            return val.Key + "=" + val.Value;
        })
    } else {
        mappedParams = $.map(params, function (val, key) {
            return key + "=" + val;
        });
    }

    return mappedParams.join("&");
}

export function alert(message: string, title: string = null, options: IPopupAlertOptions = null): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        var popup = new Popup();


        /* Create options object (with default values if none are specified) */
        var defaultOptions: IPopupConfirmOptions = {
            draggable: false,
            confirmButtonText: i18n.getMessage('dialog.ok')
        }
        options = $.extend(defaultOptions, options);

        var $content = $('<div><p>' + message + '</p></div>');
        var $buttonGroup = $('<div class="btn-group" style="width: 100%; margin-top: 10px;" role="group"></div>');
        var $okButton = $('<button type="button" class="btn btn-primary button-ok capitalize">' + options.confirmButtonText + '</button>');

        $buttonGroup.append($okButton);
        $content.append($buttonGroup);

        $okButton.on('click', (e) => {
            e.preventDefault();
            popup.close();
        });

        /* Show popup */
        popup.show({
            draggable: options.draggable,
            className: options.className,
            height: options.height,
            minHeight: options.minHeight,
            width: options.width,
            minWidth: options.minWidth,
            maximizable: options.maximizable,

            content: $content,
            title: title != null ? title : i18n.getMessage('dialog.alert'),
            close: (e) => {
                popup = null;
                resolve(true);
            }
        });
    });
}

export function confirm(message: string, title: string = null, options: IPopupConfirmOptions = null): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        var popup = new Popup();
        var result = false;

        /* Create options object (with default values if none are specified) */
        var defaultOptions: IPopupConfirmOptions = {
            draggable: false,
            confirmButtonText: i18n.getMessage('dialog.ok'),
            cancelButtonText: i18n.getMessage('dialog.cancel')
        }
        options = $.extend(defaultOptions, options);

        /* Build buttons */
        var $content = $('<div><p>' + message + '</p></div>');
        var $buttonGroup = $('<div class="btn-group" style="width: 100%; margin-top: 10px;" role="group"></div>');
        var $okButton = $('<button type="button" class="btn btn-primary button-ok capitalize">' + options.confirmButtonText + '</button>');
        var $cancelButton = $('<button type="button" class="btn btn-link button-cancel capitalize pull-right">' + options.cancelButtonText + '</button>');

        $buttonGroup.append($okButton);
        $buttonGroup.append($cancelButton);
        $content.append($buttonGroup);

        /* Button handlers */
        $okButton.on('click', (e) => {
            e.preventDefault();
            result = true;
            popup.close();
        });

        $cancelButton.on('click', (e) => {
            e.preventDefault();
            popup.close();
        });


        /* Show popup */
        popup.show({
            draggable: options.draggable,
            className: options.className,
            height: options.height,
            minHeight: options.minHeight,
            width: options.width,
            minWidth: options.minWidth,
            maximizable: options.maximizable,

            content: $content,
            title: title != null ? title : i18n.getMessage('dialog.confirm'),
            close: (e) => {
                popup = null;
                if (result) {
                    resolve(result);
                } else {
                    reject();
                }
            }
        });
    });
}



export function confirmWithPrompt(title: string = null, warningText: string, confirmText: string, confirmValue: string, options: IPopupConfirmOptions = null): Promise < any > {
    return new Promise<any>((resolve, reject) => {
        var popup = new Popup();
        var result = false;

        /* Create options object (with default values if none are specified) */
        var defaultOptions: IPopupConfirmOptions = {
            draggable: false,
            confirmButtonText: i18n.getMessage('dialog.ok'),
            cancelButtonText: i18n.getMessage('dialog.cancel')
        }
        options = $.extend(defaultOptions, options);

        /* Build buttons */
        var $content = $('<div><div><p>' + warningText + '</p></div><br><div><p>' + confirmText + '</p><input type="text" class="input-confirm" style="width:100%" /></div></div>');
        var $buttonGroup = $('<div class="btn-group" style="width: 100%; margin-top: 10px;" role="group"></div>');
        var $okButton = $('<button type="button" class="btn btn-primary button-ok capitalize" disabled>' + options.confirmButtonText + '</button>');
        var $cancelButton = $('<button type="button" class="btn btn-link button-cancel capitalize pull-right">' + options.cancelButtonText + '</button>');

        $buttonGroup.append($okButton);
        $buttonGroup.append($cancelButton);
        $content.append($buttonGroup);

        $content.find('.input-confirm').on('input', function (e) {
            if (confirmValue.toUpperCase() === (<string>$(this).val()).toUpperCase()) {
                $okButton.prop('disabled', false);
            } else {
                $okButton.prop('disabled', true);
            }
        });

        /* Button handlers */
        $okButton.on('click', (e) => {
            e.preventDefault();
            result = true;
            popup.close();
        });

        $cancelButton.on('click', (e) => {
            e.preventDefault();
            popup.close();
        });


        /* Show popup */
        popup.show({
            draggable: options.draggable,
            className: options.className,
            height: options.height,
            minHeight: options.minHeight,
            width: options.width,
            minWidth: options.minWidth,
            maximizable: options.maximizable,

            content: $content,
            title: title != null ? title : i18n.getMessage('dialog.confirm'),
            close: (e) => {
                popup = null;
                if (result) {
                    resolve(result);
                } else {
                    reject();
                }
            }
        });
    });
}

export function prompt(message: string, defaultValue: string = null, title: string = null): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        var popup = new Popup();
        var result: string = null;

        var $content = $('<div><p>' + message + '</p><input type="text" class="form-control user-input" /></div>');
        var $buttonGroup = $('<div class="btn-group" style="width: 100%; margin-top: 10px;" role="group"></div>');
        var $okButton = $('<button type="button" class="btn btn-primary button-ok capitalize">' + i18n.getMessage('dialog.ok') + '</button>');
        var $cancelButton = $('<button type="button" class="btn btn-link button-cancel capitalize pull-right">' + i18n.getMessage('dialog.cancel') + '</button>');

        $buttonGroup.append($okButton);
        $buttonGroup.append($cancelButton);
        $content.append($buttonGroup);

        var $input = $content.find('.user-input');
        $input.val(defaultValue);
        $okButton.prop('disabled', defaultValue == null || defaultValue === '');
        $input.on('input', () => {
            var inputValue = $input.val();
            $okButton.prop('disabled', inputValue == null || inputValue === '');
        });

        $okButton.on('click', (e) => {
            e.preventDefault();
            result = $input.val().toString();
            popup.close();
        });

        $cancelButton.on('click', (e) => {
            e.preventDefault();
            popup.close();
        });

        popup.show({
            draggable: false,
            content: $content,
            title: title != null ? title : i18n.getMessage('dialog.prompt'),
            close: (e) => {
                popup = null;
                if (result != null && result !== '') {
                    resolve(result);
                } else {
                    reject();
                }
            }
        });
    });
}

export default class Popup {
    private options: IPopupShowOptions;
    private topicName: string;
    private ignoreIframeLoadedEvent = true;
    private _win: kendo.ui.Window;
    private $popupWrapper: JQuery = $('<div id="CMSPopup_WidgetWrapper"></div>');;
    private _d = $('<div id="CMSPopup"></div>');
    private $wait = $('<div id="CMSPopup_Wait wait"></div>');
    private _closeFuncCalled = false;
    private subscription: any;
    private globalSubscription: any;
    private _global: any;
    private _instance: any;
    private $iframe: JQuery;


    public get topic(): string {
        return this.topicName;
    }
    public get maxWidth(): number {
        return $(window).width() - 60;
    }
    public get maxHeight(): number {
        return $(window).height() - 100;
    }

    public constructor() {
        this.topicName = "AWF.popup.1";
    }

    public show(options: IPopupShowOptions) {
        /* Webkit browsers fire load event twice => once when added to DOM, once when content is loaded, prevent first one*/
        var _p = this;

        var _doc = $(document);
        var $win = $(window);

        var _win = null;
        var _closeFuncCalled = false;

        var _app = app.getAWFConfig();
        this._global = options.global != null ? options.global : _app.g;
        this._instance = options.instance != null ? options.instance : { a: null, app: null, appconf: null, iid: options.iidWidget, p: options.params, ru: null, w: options.widget };


        options.width = options.width != null ? Math.min(options.width, this.maxWidth) : null;
        options.height = options.height != null ? Math.min(options.height, this.maxHeight) : null;

        options.minWidth = options.minWidth != null ? Math.min(options.minWidth, this.maxWidth) : null;
        options.minHeight = options.minHeight != null ? Math.min(options.minHeight, this.maxHeight) : null;
        this.options = options;

        var layoutClass = $('#Lw').attr('class');
        this.$popupWrapper.addClass(layoutClass);

        if (options.content != null) {
            this.$popupWrapper.append(options.content);
        }
        this._d.append(this.$popupWrapper);
        this.subscription = publisher.subscribe(this.topicName, (action: string, param: any) => { this._receiveMessages(action, param); });

        var isIFramePopup = false;

        /* Load & render content */
        if (options.actionID != null) {
            this.loadWidget("ID%20eq%20guid'" + options.actionID + "'", "ActionType,App,ClientID,Html,ID,ParamsInst,ParamsModdef,ParamsModdefWU, WdName", options); //selecteer enkel ActionType, ClientID Html en WdName
        } else if (options.widget != null) {
            this.loadWidget("ClientID%20eq%20'" + options.widget + "'", null, options); //Selecteer alles
        } else if (options.page != null) {
            isIFramePopup = true;
            this.renderPageControl(options.page, this._instance.p, options);
        } else if (options.pageID != null) {
            isIFramePopup = true;
            this.renderPageIDControl(options.pageID, this._instance.p, options);
        } else if (options.url != null) {
            isIFramePopup = true;
            this.renderUrlControl(options);
        } else if (options.html != null) {
            this.renderJQueryControl($(<string>options.html));
        }


        var _kendoParams: kendo.ui.WindowOptions = {
            animation: false,
            //animation: { open: { effects: "zoom:in"} },
            visible: false,
            actions: ['Close'],
            modal: true,
            draggable: true,
            resizable: false,
            title: options.title,
            close: (e: any) => { this.closed(e); },
            resize: (e: any) => { this.resized(e); }
        };


        /* Limit popup size (non-iframe popups). IFrames are limited to maxWidth & maxHeight */
        if (!isIFramePopup) {
            _kendoParams.maxHeight = this.maxHeight;
            _kendoParams.maxWidth = this.maxWidth;
        }


        if (options.draggable) { _kendoParams.draggable = options.draggable; }
        if (options.width != null) { _kendoParams.width = options.width; }
        if (options.height != null) { _kendoParams.height = options.height; }
        if (options.minWidth != null) { _kendoParams.minWidth = options.minWidth; }
        if (options.minHeight != null) { _kendoParams.minHeight = options.minHeight; }
        if (options.maximizable != null && options.maximizable == true) { _kendoParams.actions.unshift('Maximize'); }

        if ($("#fullscreen-element-popup-wrapper").length > 0) {
            $("#fullscreen-element-popup-wrapper").append(this._d);
            $("#fullscreen-element-popup-wrapper").css('display', 'block');            
            _kendoParams.appendTo = "#fullscreen-element-popup-wrapper";
        } else {
            $(document.body).append(this._d);
        }
        

        this._d.kendoWindow(_kendoParams);
        this.ignoreIframeLoadedEvent = false;
        this._win = this._d.data("kendoWindow");        
        this._d.data('awfPopup', this);

        if (options.displayMode === 'legacy') {
            /* In legacy mode the CMSPopup_WidgetWrapper height is NOT limited to the maxHeight */
            this._win.wrapper.find('#CMSPopup_WidgetWrapper')[0].style.height = '100%'; // backwards compatiblity (code bestond reeds)                    
        } else {
            /* In flex mode the CMSPopup_WidgetWrapper is limited to the available content space */
            this._win.wrapper.find('.k-window-content')[0].style.display = 'flex';

            this._win.wrapper.find('#CMSPopup_WidgetWrapper')[0].style.flex = '1';
            this._win.wrapper.find('#CMSPopup_WidgetWrapper')[0].style.display = 'flex';
            this._win.wrapper.find('#CMSPopup_WidgetWrapper')[0].style.flexDirection = 'column';
            this._win.wrapper.find('#CMSPopup_WidgetWrapper')[0].style.maxWidth = '100%';
            this._win.wrapper.find('#CMSPopup_WidgetWrapper')[0].style.maxHeight = '100%';
        }


        /* Retrieve all img tags => this is used to recenter popup once the images are loaded */
        var $images = this._d.find('img');
        $images.on('load', () => {
            this._win.center(); /* center popup if image loads */
        });


        this._win.center();
        this._win.open();

        if (options.content == null) {
            this._win.wrapper.addClass("a-popup");
        }
        if (options.className != null) {
            this._win.wrapper.addClass(options.className);
        }
    }




    public showError(message: string, title?: string) {
        return this.show({
            title: title ?? 'Fout',
            content: '<div><span class="ui-icon ui-icon-alert" style="float: left; margin-right: .3em;"></span>' + message + '</div>',
            className: 'a-error'
        });
    }

    public showWarning(message: string, title?: string) {
        return this.show({
            title: title ?? "Waarschuwing",
            content: '<div class="ui-widget"><div class="ui-state-highlight ui-corner-all" style="padding: 0 .7em;"><p><span class="ui-icon ui-icon-notice" style="float: left; margin-right: .3em;"></span>' + message + '</p></div></div>'
        });
    }
    public close(data?: any) {
        this.closeFunc({ dialog: this._d, value: data });
    }



    private resizeIFrame(o: IPopupResizeIFrameOptions, addReadyHandler?: boolean) {
        var additionalHeight = 1;

        var iframe = <HTMLIFrameElement>o.$iframe[0];
        var $doc = $(iframe.contentDocument);

        /* Check if we should resize on document ready */
        if (addReadyHandler === true) {
            $doc.ready(() => {
                /* call resize iframe again when document is ready */
                this.resizeIFrame(o, false);
            });
        }


        var $html = $doc.find("html");
        var scrollbarWidth = getScrollBarWidth();

        /* Get title of popup */
        var title = (this.options.title ? this.options.title : $.trim($html.find("title").text()));

        /* Set height and width to values provided in options  */
        /* if these are empty determine value according to content of iframe */
        var height = this.options.height;
        var width: number | string = this.options.width;

        if (height == null) {
            /* Search height according to document.height, document.scrollHeight, html.height */
            var docHeight = $doc.height(); //docheight can be different from html height (eg. IE9)
            var htmlHeight = $html.length > 0 ? $html.height() : 0;

            /* Height is set to maximum of the values above */
            height = Math.max(docHeight, htmlHeight, this.options.minHeight)
            height += additionalHeight + scrollbarWidth;
        }

        if (width == null) {
            /*Set width to width of document */
            width = Math.max($doc.width(), this.options.minWidth) + scrollbarWidth;
        } else {
            /* Width was configured => popup has a width; set width of iframe to 100% */
            width = '100%';
        }

        if (this.maxHeight != null && this.maxHeight > 0 && height > this.maxHeight) {
            height = this.maxHeight;
        }
        if (this.maxWidth != null && this.maxWidth > 0 && <number>width > this.maxWidth) {
            width = this.maxWidth;
        }

        o.$iframe.css('height', height);
        o.$iframe.css('width', width);

        if (this._win != null) {
            this._win.center();
            this._win.title(title);
        }
    }


    private renderIFrameControl($parent: JQuery, url: string, o: any) {
        var _name = 'awfPopup';
        var $i = $('<iframe />', {
            name: _name,
            className: _name,
            id: _name,
            src: url,
            seamless: true,
            topic: this.topicName
        });

        var minHeight = $parent.css('min-height');
        var maxHeight = o != null ? o.maxHeight : null;

        this.$iframe = $i;

        $i.on('load', (evt) => {
            if (!this.ignoreIframeLoadedEvent) {
                $parent.removeClass('k-loading')
                $parent.css('min-height', minHeight);
                $i.css('display', 'block');

                /* Make sure a scrollbar is shown if needed */
                /* Note: overflow is set on body and not on html as this gives problems with Ad Block Plus*/

                var iframe = <HTMLIFrameElement>$i[0];
                var $body = $(iframe.contentDocument).find('body');
                $body.css('overflow', 'auto');

                /* Call resizeIframe to set minWidth & minHeight values according to the content in the iframe*/
                this.resizeIFrame({ $iframe: $i, maxHeight: maxHeight });
            }
        });

        $parent.addClass('k-loading');
        $i.css('display', this.options.iframeVisible === 'immediate' ? 'block': 'none');
        $i.css('border', 'none');
        $parent.append($i);
        var minH = parseInt(minHeight);
        if (isNaN(minH) || minH < 50) { $parent.css('min-height', '50px'); }

        /* subscribe to all topics and sent them to the iframe. Retained data not supported for the moment */
        this.globalSubscription = publisher.subscribeAll((topic: string, ...data: any[]) => {
            (<HTMLIFrameElement>$i[0]).contentWindow.postMessage({ type: 'awf.topublish', topic: topic, data: JSON.stringify(data) }, '*');
        }, false);
    }


    private renderPageControl(page: any, params: IPopupParamsArray | IPopupParamsObject, options: IPopupShowOptions) {
        var url = '/default.aspx?path=' + page + "&" + getParamStr(params);
        this.renderIFrameControl(this.$popupWrapper, url, options);
    }

    private renderPageIDControl(pageId: string, params: IPopupParamsArray | IPopupParamsObject, options: IPopupShowOptions) {
        var url = '/default.aspx?pageID=' + pageId + "&" + getParamStr(params);
        if (options.anchor != null) { url = kendo.format("{0}#{1}", url, options.anchor); };
        this.renderIFrameControl(this.$popupWrapper, url, options);
    }

    private renderUrlControl(options: IPopupShowOptions) {
        this.renderIFrameControl(this.$popupWrapper, options.url, options);
    }

    private renderUserControl(info: any, options: IPopupShowOptions) {
        var url = '/default.aspx?ci=' + info.ClientID + '&' + getParamStr(options.params); //Params gebruiken die meegegeven werden met popup
        this.renderIFrameControl(this.$popupWrapper, url, options);
    }


    private renderHtmlControl(moduleName: string, info: any) {
        import(moduleName).then(mod => {
            var awfConfig = (<any>window).awfConfig;

            if (info.Html == null) info.Html = "";
            var $html = $('<div class="' + info.WdName + '">' + info.Html + '</div>');

            /* Render content */
            this.renderJQueryControl($html);

            /* Add widget specific css */
            if (info.Css != null && info.Css != "") {
                addStyleSheets(info.Css.split(';'));
            }

            /* Create new widget instance */
            var widgetInstance: any;
            if (mod["default"] != null) {
                widgetInstance = new mod["default"](); /* Create instance */
            } else {
                widgetInstance = new mod();
            }


            /* Create widget parameters */
            var widgetParameters = {};
            $.extend(widgetParameters, info.Params);
            $.extend(widgetParameters, this._instance.p);
            $.extend(widgetParameters, conf.getModInstParamsForUser(this._instance.iid));


            /* Create widget options */
            var widgetOptions = {
                root: $html[0],
                lang: this._global.l,
                params: widgetParameters,
                popupTopic: this.topicName,
                rootUrl: app.getAppInfo(info.App).location,
                iid: this._instance.iid,
                currentUser: this._global.cu,
                page: this._global.p,
                dashboards: awfConfig.g.db
            };
            if (widgetOptions.params == null) { widgetOptions.params = {}; }

            /* Initialize the widget */
            widgetInstance.initialize(widgetOptions);

            /* Store widget */
            this._d.data("widget", widgetInstance);

            /* Execute widgetLoaded event */
            if (this.options.widgetLoaded) {
                this.options.widgetLoaded(widgetInstance);
            }
        });
    }

    private renderJQueryControl($content: JQuery) {
        $content.appendTo(this.$popupWrapper);
        if (this._win) { this._win.center(); }
    }

    private _receiveMessages(action: string, parameter: any) {
        switch (action) {
            case 'close':
                this.closeFunc({ dialog: this._d, value: parameter });
                break;
            case 'restore':
                this.restore();
                break;
            case 'maximize':
                this.maximize();
                break;
            case 'resize':
                this.resize();
                break;
            case 'destroyed':
                /* iframe page was destroyed */
                console.log('iframe page destroyed', parameter);
                break;
        }
    }

    public restore() {
        if (this._win != null) {
            this._win.restore();
        }
    }

    public maximize() {
        if (this._win != null) {
            this._win.maximize();
        }
    }

    public resize() {
        var _i = this._d.find('iframe');
        if (_i.length != 0) {
            this.resizeIFrame({ $iframe: this._d.find('iframe') });
        } else {
            if (this._win != null) {
                this._win.resize();
                this._win.center();
            }
        }
    }

    private loadWidget(filter: string, fields: string, options: any) {
        this.$popupWrapper.append(this.$wait);

        /* Load widget data from AWF using an OData service */
        getWidgetData(filter, fields).then((val) => {
            if (val.value.length == 1) {
                var value = val.value[0];
                var _params = {};

                value.ParamsModdef = serverSideToClientSideParams(value.ParamsModdef);
                value.ParamsModdefWU = serverSideToClientSideParams(value.ParamsModdefWU);
                value.ParamsInst = serverSideToClientSideParams(value.ParamsInst);

                $.extend(_params, conf.getAppParams(value.App));
                $.extend(_params, conf.getAppParamsForUser(value.App));
                $.extend(_params, value.ParamsModdef);
                $.extend(_params, value.ParamsModdefWU);
                $.extend(_params, conf.getPageParams());
                $.extend(_params, conf.getPageParamsForUser());
                $.extend(_params, value.ParamsInst);
                value.Params = _params;

                var _at = value.ActionType;
                if (_at == 'Html') {
                    this.renderHtmlControl(val.value[0].ClientID, value);
                } else if (_at == "Usercontrol") {
                    this.renderUserControl(val.value[0], options);
                } else {
                    this.showError('The actionType "' + _at + '" is unknown.');
                    this._win.close();
                }
            } else if (val.value.length > 1) {
                this.showError("Found more then 1 widget with this name: '<b>" + options.widget + "</b>'");
                this._win.close();
            } else {
                const url = app.formatLocationUrl("~/odata/awfdataservice.svc/WebmoduleActions") + "?$filter=ClientID%20ne%20null&$orderby=ClientID&$select=ClientID&$format=json";
                this.showError("Couldn't find any widget with this name: '<b>" + options.widget + "</b>' <br /> <a href=\"" + url + "\">[List of possible widgets]</a>");
                this._win.close();
            }
        });
    }

    private getState() {
        var _state = (<any>this._win.options).isMaximized ? 'maximized' : 'normal';
        var popupContent = this._win.element;
        var _pos = popupContent.offset();
        return {
            top: _pos.top,
            left: _pos.left,
            visible: true,
            width: popupContent.width(),
            height: popupContent.height(),
            state: _state/*, top: _pos.top, left: _pos.left */
        };
    }

    private sendAction(action: string, state: any) {
        publisher.publish(this.topicName, { action: action, state: state });
    }

    private resized(e: any) {
        if ((<any>this._win.options).isMaximized) {
            //this._win.setOptions({
            //    maxWidth: 999999,
            //    maxHeight: 999999
            //});
            this.sendAction("maximize", this.getState());
        } else {
            this.sendAction("maximize", this.getState());
            this._win.setOptions({
                maxWidth: this.maxWidth,
                maxHeight: this.maxHeight
            });
        }
    }
    private closed(e: any) {
        if (this.subscription != null) { this.subscription.detach(); }
        if (this.globalSubscription != null) { this.globalSubscription.detach(); }
        var _e = this.options.params || {};

        /* call destroy function for widget */
        var _mod = this._d.data("widget");
        if (_mod != null) { if (_mod.destroy != null) { _mod.destroy(_e); } }

        /* send destroy message to iframe */
        if (this.$iframe != null && this.$iframe.length > 0) {
            (<HTMLIFrameElement>this.$iframe[0]).contentWindow.postMessage({ type: 'awf.topublish', topic: 'CMS.Page', action: 'destroy' }, '*');
        }

        if (this.options.close != null) { this.options.close(_e); }
        e.sender.destroy();

    }
    private closeFunc(closeOptions: any) {
        if (this._closeFuncCalled) { return true; }
        this._closeFuncCalled = true;

        /* Retrieve params => these are returned in the closed event */
        var e = this.options.params || {};

        /* TODO : onderzoeken waarvoor deze code dient (waarom element 1 van array? wat is element 0 ???) ...*/
        if (closeOptions.value != null && closeOptions.value[1] != null) {
            $.extend(e, closeOptions.value[1]);
        } else {
            $.extend(e, closeOptions.value);
        }

        /* Update params */
        this.options.params = e;

        this._win.close();
    }
}